import { PostPayoutResponse } from 'services/api/responses/responseTypes';
import { baseApi } from '../base';
import { TagType } from '../base/baseApi';
import { Payout } from '../entities';
import { transformToError, transformToPayout } from './transformers';

const payoutsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getEarnings: build.query<Payout, void>({
      query: () => ({ url: 'payouts/available' }),
      providesTags: [TagType.PAYOUTS],
      transformResponse: transformToPayout,
      transformErrorResponse: transformToError,
    }),
    withdrawEarnings: build.mutation<PostPayoutResponse, void>({
      query: () => ({ url: 'payouts', method: 'POST' }),
      invalidatesTags: (_, error) => (error ? [] : [TagType.PAYOUTS]),
      transformErrorResponse: transformToError,
    }),
  }),
});

export default payoutsApi;
